import React from "react";
import claudia from "../../assets/images/mamaMiguel/claudia.jpg";
import "./style.css";

const InMemoriam = () => {
  return (
    <section id="in-memoriam">
      <div className="memoriam-body" data-aos="fade-up" data-aos-duration="1200">

        <img
          className="memoriam-dove"
          src="https://img.icons8.com/ios/48/b28c5d/dove.png"
          alt=""
        />

        <p className="memoriam-label">En Memoria</p>
        <div className="memoriam-rule" />

        <div className="memoriam-photo-wrap">
          <img
            className="memoriam-photo"
            src={claudia}
            alt="Claudia Alejandra Calderón Leaños"
          />
        </div>

        <h2 className="memoriam-name">Claudia Alejandra Calderón Leaños</h2>

        <div className="memoriam-rule memoriam-rule--short" />

        <p className="memoriam-quote">
          "Hoy camino hacia una nueva historia llevando tu amor conmigo, mamá.
            Siempre conmigo, siempre en mi corazón."
        </p>

      </div>
    </section>
  );
};

export default InMemoriam;
